import {Inject, Injectable} from "@angular/core";
import {ConfigurationService, EntityService, JwtHttpClientService, ResourceModule} from "@fedeltapointofsale/data-client";

/**
 * Service to retrieve the icon for a sellable
 */
@Injectable()
export class SellableIconService extends EntityService {
    constructor(http: JwtHttpClientService,
                configService: ConfigurationService,
                @Inject(ResourceModule.RESOURCE_NAMESPACE_KEY) nameSpace: string,
                @Inject(ResourceModule.ENTITY_NAMES_KEY) entityNames: string[],
                @Inject(ResourceModule.RESOURCE_USE_ASYNC) useAsync: boolean) {
        super(http, configService, nameSpace, entityNames, "sellable-icon", 0, useAsync);
    }
}
